
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Circle } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: string;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  switch (status) {
    case "actie_decoprof":
      return (
        <Badge variant="outline" className="flex items-center gap-2" style={{ backgroundColor: "rgba(41, 56, 75, 0.15)", color: "#29384b" }}>
          <Circle fill="#29384b" color="#29384b" size={12} />
          Actie Decoprof
        </Badge>
      );
    case "actie_luijten":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-red-100 text-red-800 hover:bg-red-100">
          <Circle fill="#f4323f" color="#f4323f" size={12} />
          Actie Luijten
        </Badge>
      );
    case "actie_winkel_ridderkerk":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-black/10 text-black hover:bg-black/10">
          <Circle fill="#000000" color="#000000" size={12} />
          Actie winkel Ridderkerk
        </Badge>
      );
    case "afwachting_klant":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-pink-100 text-pink-800 hover:bg-pink-100">
          <Circle fill="#F472B6" color="#F472B6" size={12} />
          In afwachting van klant
        </Badge>
      );
    case "afwachting_voorraad":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-amber-100 text-amber-800 hover:bg-amber-100">
          <Circle fill="#F59E0B" color="#F59E0B" size={12} />
          In afwachting van nieuwe voorraad
        </Badge>
      );
    case "afwachting_voorraad_ridderkerk":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-orange-100 text-orange-800 hover:bg-orange-100">
          <Circle fill="#EA580C" color="#EA580C" size={12} />
          In afwachting van nieuwe voorraad winkel Ridderkerk
        </Badge>
      );
    case "afwijkende_verzenddatum":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-purple-100 text-purple-800 hover:bg-purple-100">
          <Circle fill="#9061F9" color="#9061F9" size={12} />
          Afwijkende verzenddatum
        </Badge>
      );
    case "afgerond":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-green-100 text-green-800 hover:bg-green-100">
          <Circle fill="#34C759" color="#34C759" size={12} />
          Afgerond
        </Badge>
      );
    case "open":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-red-100 text-red-800 hover:bg-red-100">
          <Circle fill="#ea384c" color="#ea384c" size={12} />
          Actie Luijten
        </Badge>
      );
    case "in_behandeling":
      return (
        <Badge variant="outline" className="flex items-center gap-2" style={{ backgroundColor: "rgba(41, 56, 75, 0.15)", color: "#29384b" }}>
          <Circle fill="#29384b" color="#29384b" size={12} />
          Actie Decoprof
        </Badge>
      );
    case "opgelost":
      return (
        <Badge variant="outline" className="flex items-center gap-2 bg-green-100 text-green-800 hover:bg-green-100">
          <Circle fill="#34C759" color="#34C759" size={12} />
          Afgerond
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

interface PriorityBadgeProps {
  priority: string;
}

export const PriorityBadge = ({ priority }: PriorityBadgeProps) => {
  switch (priority) {
    case "hoog":
      return (
        <Badge 
          variant="outline" 
          className={cn(
            "bg-red-100 text-red-800 hover:bg-red-100 animate-pulse-attention"
          )}
        >
          Hoog
        </Badge>
      );
    case "normaal":
      return <span className="text-white">-</span>;
    case "middel":
      return <Badge variant="outline" className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">Middel</Badge>;
    case "laag":
      return <Badge variant="outline" className="bg-green-100 text-green-800 hover:bg-green-100">Laag</Badge>;
    default:
      return <Badge variant="outline">{priority}</Badge>;
  }
};
